import path from 'node:path'
import { snapshotRoot } from './snapshot-root.js'

export function scopeDir(cwd: string, scope: string): string {
  return path.join(snapshotRoot(cwd), scope)
}
